import { Spinner } from '../../../components/common';
import { EngagementSummaryReport, useEngagementSummaryReport } from '../../../hooks/useEngagementReporting';
import { EngagementReportFilters } from '../common/reports-constants';

interface EngagementSummaryFilters {
  filters: EngagementReportFilters;
}

export const EngagementSummary: React.FC<EngagementSummaryFilters> = ({ filters }) => {
  const { data: engagementSummaryReport, isLoading } = useEngagementSummaryReport(filters);

  return (
    <div className="max-w-6xl p-4">
      <h1 className="mb-4 text-2xl font-bold">Engagements Summary Report</h1>
      <div className="overflow-x-auto">
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            <table className="min-w-full border border-gray-200 bg-white font-mono">
              <thead>
                <tr className="bg-gray-100 text-left">
                  <th className="border-b px-4 py-2">Date</th>
                  <th className="border-b px-4 py-2">Peer Support</th>
                  <th className="border-b px-4 py-2">External Support</th>
                </tr>
              </thead>
              <tbody>
                {engagementSummaryReport?.data.map((summary: EngagementSummaryReport, index: any) => (
                  <tr key={index} className={`text-sm ${!summary.date && 'bg-gray-200'}`}>
                    <td className="w-1/6 border-b px-4 py-2 align-top">
                      <div className={`${!summary.date && 'font-bold'}`}>{summary.date || 'Rollup'}</div>
                      <div className="flex justify-between">
                        <p> Total: </p>
                        <p className="font-bold">{summary.engagements}</p>
                      </div>
                    </td>
                    <td className="w-1/4 border-b px-4 py-2 align-top">
                      <div className="flex justify-between">
                        <p>Audio Plays:</p>
                        <p className="font-bold">{summary.audio_play}</p>
                      </div>
                      <div className="flex justify-between">
                        <p>Video Plays:</p>
                        <p className="font-bold">{summary.video_play}</p>
                      </div>
                      <div className="flex justify-between">
                        <p>Calls Completed:</p>
                        <p className="font-bold">{summary.calls_completed}</p>
                      </div>
                    </td>
                    <td className="w-3/5 whitespace-nowrap border-b py-2 pl-4 pr-12 align-top">
                      <div className="flex items-center space-x-2">
                        <div className="flex w-1/2 justify-between">
                          <p>+Care Engagements:</p>
                          <p className="font-bold">{summary.provider_engagement}</p>
                        </div>
                        <div className="flex w-1/2 space-x-2 pl-6 text-sm">
                          <p>
                            (Views: <span className="font-bold">{summary.provider_view}</span>
                          </p>
                          <p>
                            Impressions: <span className="font-bold">{summary.provider_impression}</span>)
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        <div className="flex w-1/2 justify-between">
                          <p>Program Engagements:</p>
                          <p className="font-bold">{summary.client_resource_engagement}</p>
                        </div>
                        <div className="flex w-1/2 space-x-2 pl-6 text-sm">
                          <p>
                            (Views: <span className="font-bold">{summary.client_resource_view}</span>
                          </p>
                          <p>
                            Impressions: <span className="font-bold">{summary.client_resource_impression}</span>)
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        <div className="flex w-1/2 justify-between">
                          <p>Resource Engagements:</p>
                          <p className="font-bold">{summary.global_resource_engagement}</p>
                        </div>
                        <div className="flex w-1/2 space-x-2 pl-6 text-sm">
                          <p>
                            (Views: <span className="font-bold">{summary.global_resource_view}</span>
                          </p>
                          <p>
                            Impressions: <span className="font-bold">{summary.global_resource_impression}</span>)
                          </p>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
};
